export type Key9InputGateState = {
  inputLocked: boolean;
  terminalEntered: boolean;
  terminalTransitions: number;
};

export type Key9PlacementGateResult = {
  accepted: boolean;
  state: Key9InputGateState;
};

export function createKey9InputGateState(overrides: Partial<Key9InputGateState> = {}): Key9InputGateState {
  return {
    inputLocked: false,
    terminalEntered: false,
    terminalTransitions: 0,
    ...overrides
  };
}

export function beginKey9PlacementAttempt(state: Key9InputGateState): Key9PlacementGateResult {
  if (state.inputLocked || state.terminalEntered) {
    return { accepted: false, state };
  }

  return {
    accepted: true,
    state: {
      ...state,
      inputLocked: true
    }
  };
}

export function finishKey9PlacementFeedback(state: Key9InputGateState): Key9InputGateState {
  if (state.terminalEntered) return state;

  return {
    ...state,
    inputLocked: false
  };
}

export function enterKey9TerminalState(state: Key9InputGateState): Key9InputGateState {
  if (state.terminalEntered) return state;

  return {
    ...state,
    inputLocked: true,
    terminalEntered: true,
    terminalTransitions: state.terminalTransitions + 1
  };
}

export function resetKey9InputGate(): Key9InputGateState {
  return createKey9InputGateState();
}
